import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiButtonComponent } from '../ui-button/ui-button.component';

@Component({
  selector: 'ui-form-action-footer',
  standalone: true,
  imports: [UiButtonComponent],
  templateUrl: './ui-form-action-footer.component.html',
  styleUrl: './ui-form-action-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormActionFooterComponent {
  readonly showBack = input(false);
  readonly showSave = input(true);
  readonly showNext = input(false);
  readonly isSaving = input(false);
  readonly disableBack = input(false);
  readonly disableSave = input(false);
  readonly disableNext = input(false);
  readonly backLabel = input('Back');
  readonly saveLabel = input('Save');
  readonly nextLabel = input('Next');
  readonly backClicked = output<void>();
  readonly saveClicked = output<void>();
  readonly nextClicked = output<void>();

  onBackClicked(): void {
    this.backClicked.emit();
  }

  onSaveClicked(): void {
    this.saveClicked.emit();
  }

  onNextClicked(): void {
    this.nextClicked.emit();
  }
}
